export type GlobalBreadcrumbItem = {
  label: string;
  to: string;
};

export type GlobalBreadcrumbState = {
  path: string;
  items: GlobalBreadcrumbItem[];
  hidden: boolean;
};

export const useGlobalBreadcrumbs = () =>
  useState<GlobalBreadcrumbState>("global-breadcrumbs", () => ({
    path: "",
    items: [],
    hidden: true,
  }));
